export default "__VITE_ASSET__B9Ne4j4N__"